import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import withErrorGuard from "../../HOC/withErrorGuard";
import SampleViewInternal from "./SampleViewInternal";
import {
  getVariantPos,
  getVariantResult,
  getQueryType,
  getChromosome,
  getGenome,
  getVariantId,
} from "../../state/selectors/general.selectors";
import {
  getAcmgTranscript,
  getPrimeTranscript,
  getCnvTranscript,
} from "../../state/selectors/Pulsar.selectors";

function SampleBrowser(props) {
  const {
    analysis_id: analysisId,
    is_multi_sample_analysis: isMulti,
    root_analysis: rootAnalysis,
    analysisHasPhasingGroup: hasPhasingGroups,
  } = window.resultsConfig || {};

  return (
    <SampleViewInternal
      {...props}
      isMulti={isMulti}
      hasPhasingGroups={hasPhasingGroups}
      rootAnalysis={String(rootAnalysis)}
      analysisId={String(analysisId)}
    />
  );
}

SampleBrowser.propTypes = {
  refLength: PropTypes.number,
  cnvLength: PropTypes.number,
  position: PropTypes.number.isRequired,
  variantId: PropTypes.string,
  mainTranscriptLength: PropTypes.number,
  queryType: PropTypes.string.isRequired,
  acmgTranscript: PropTypes.string,
  genome: PropTypes.string,
  cnvTranscript: PropTypes.string,
};

SampleBrowser.defaultProps = {
  variantId: null,
  genome: null,
  mainTranscriptLength: 0,
  refLength: 0,
  cnvLength: 0,
  acmgTranscript: null,
  cnvTranscript: "",
};

const mapStateToProps = (state) => {
  return {
    position: getVariantPos(state),
    variantId: getVariantId(state),
    queryType: getQueryType(state),
    mainTranscriptLength: getPrimeTranscript(state)?.transcriptLength,
    refLength: getVariantResult(state)?.ref?.length,
    cnvLength: getVariantResult(state)?.length,
    genome: getGenome(state).name,
    chrName: getChromosome(state),
    //
    acmgTranscript: getAcmgTranscript(state),
    cnvTranscript: getCnvTranscript(state),
  };
};

export default connect(mapStateToProps)(
  withErrorGuard(SampleBrowser, "SampleView", "Sample View")
);
